export default {
    classFix:'ark-', //class前缀
    componentsFix:'', //components前缀
    prefixCls:'ark-' //前缀
};



// WEBPACK FOOTER //
// ./src/assets/config.js